// extracted by mini-css-extract-plugin
module.exports = {"hd":"VendorAnalyticsAudience_hd__2VWt3","intro":"VendorAnalyticsAudience_intro__1N5GG","layout":"VendorAnalyticsAudience_layout__2bGDb"};